var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelperRobotComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94,
    height: 211
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "helper-robot-complete_svg__a",
    d: "M0 0h33.807v25.75H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "helper-robot-complete_svg__c",
    d: "M0 0h11.116v37.196H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "helper-robot-complete_svg__e",
    d: "M0 0h33.808v25.75H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.193 70.814)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "helper-robot-complete_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#helper-robot-complete_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA852",
    d: "M13.783 16.235l-2.734 8.19c.65.216 1.308.41 1.953.575l2.142-8.364c-.448-.115-.905-.25-1.36-.401zm2.165.587l-1.73 8.46c.692.14 1.392.253 2.077.331l.984-8.578c-.437-.05-.884-.122-1.33-.213zm-4.336-1.439l-3.538 7.875c.61.275 1.23.53 1.84.761l3.05-8.077a25.252 25.252 0 01-1.352-.559zm-2.15-1.08L5.28 21.86c.543.3 1.12.602 1.724.898l3.798-7.754c-.47-.23-.919-.466-1.341-.7zM0 18.344c.065.054.664.548 1.662 1.253l4.97-7.063c-.707-.497-1.115-.831-1.12-.835L0 18.343zm7.382-5.299l-4.755 7.207c.487.322 1.036.669 1.637 1.025l4.41-7.423a32.171 32.171 0 01-1.292-.809zm16.143 2.782l4.469 7.389c.734-.445 1.41-.936 2.007-1.458l-5.69-6.495c-.217.19-.483.381-.786.564zm-5.48 1.273l-.456 8.623a20.87 20.87 0 002.208-.003l-.504-8.62c-.419.024-.833.02-1.247 0zm15.322-.496c.26-.88.398-1.807.424-2.752.003-.028.017-.052.017-.08V2.22c0-1.226-.995-2.22-2.222-2.22v13.73l-.981-.02V0h-2.222v13.663l-.982-.02V0H25.18v12.997c0 .215.046.418.127.602l-.142-.002a2.155 2.155 0 01-.083.578l8.285 2.428zm-8.722-1.67l6.49 5.695a10.85 10.85 0 001.59-2.373l-7.749-3.807a2.19 2.19 0 01-.33.484zm-3.464 1.877c-.37.096-.757.17-1.154.223l1.098 8.562c.76-.096 1.512-.242 2.234-.43l-2.178-8.355zm1.518-.545l.235-.114 3.836 7.735-.394.192a17.61 17.61 0 01-1.704.691l-2.821-8.16a9 9 0 00.848-.344z",
    mask: "url(#helper-robot-complete_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.442)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "helper-robot-complete_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#helper-robot-complete_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4B555F",
    d: "M10.764 14.53l-7.896-1.405 7.896-1.406a.428.428 0 000-.841l-7.9-1.409 2.77-.494a.428.428 0 00.352-.42v-4.06c0-.016-.008-.03-.009-.044A2.245 2.245 0 005.558 0a2.246 2.246 0 00-.419 4.451c-.002.015-.008.028-.008.043v3.702l-4.779.851A.43.43 0 000 9.47c0 .207.149.384.352.42l7.9 1.409-7.9 1.406a.428.428 0 000 .842l7.896 1.405-2.765.492a.426.426 0 00-.352.421V36.77a.427.427 0 10.855 0V16.223l4.778-.851a.428.428 0 000-.841",
    mask: "url(#helper-robot-complete_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#118A97",
    d: "M36.386 180.766l-5.12-47.379a1.282 1.282 0 011.265-1.496h5.12c.709 0 1.283.575 1.283 1.283v47.379c0 1.573-2.285 1.764-2.548.213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2AB1C0",
    d: "M57.728 180.766l5.12-47.379a1.282 1.282 0 00-1.264-1.496h-5.12c-.71 0-1.283.575-1.283 1.283v47.379c0 1.573 2.285 1.764 2.547.213"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 70.814)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "helper-robot-complete_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#helper-robot-complete_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D07C2A",
    d: "M18.663 16.636L20.806 25a29.061 29.061 0 001.952-.575l-2.734-8.19a20.33 20.33 0 01-1.36.4zm-2.134.4l.982 8.577c.687-.08 1.386-.19 2.078-.331l-1.73-8.46c-.446.09-.893.163-1.33.213zm4.314-1.094l3.052 8.077c.61-.23 1.228-.486 1.84-.76l-3.54-7.876c-.436.196-.887.383-1.352.56zm2.161-.938l3.799 7.754c.603-.296 1.18-.597 1.724-.898l-4.181-7.556c-.422.234-.871.47-1.342.7zm5.29-3.305c-.003.003-.41.337-1.117.834l4.968 7.063a27.925 27.925 0 001.663-1.253L28.295 11.7zm-3.161 2.154l4.41 7.424c.601-.357 1.15-.704 1.638-1.025l-4.755-7.208c-.384.253-.819.528-1.293.81zm-15.636 1.41l-5.69 6.494a14.245 14.245 0 002.007 1.458l4.468-7.388a5.776 5.776 0 01-.785-.565zm5.017 1.836l-.503 8.62a20.748 20.748 0 002.207.003l-.457-8.623c-.413.02-.828.024-1.247 0zm-5.789-2.924a2.237 2.237 0 01-.083-.578l-.142.002c.082-.184.128-.387.128-.602V0H6.406v13.643l-.981.02V0H3.203v13.71l-.982.02V0A2.22 2.22 0 000 2.22v11.55c0 .03.013.053.016.08.027.947.165 1.873.423 2.753l8.286-2.428zm.106.273l-7.75 3.808c.416.844.951 1.642 1.592 2.371l6.49-5.695a2.237 2.237 0 01-.332-.484zm1.617 10.717c.723.188 1.474.334 2.235.431l1.098-8.563a9.695 9.695 0 01-1.154-.223l-2.179 8.355zm1.509-8.556L9.135 24.77c-.575-.2-1.149-.432-1.704-.692l-.394-.192 3.837-7.734.234.113c.271.127.56.245.849.344z",
    mask: "url(#helper-robot-complete_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#44D9E9",
    d: "M47 142.804c5.35 0 9.899-3.377 11.668-8.11H47.001v8.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2AB1C0",
    d: "M35.333 134.694c1.768 4.733 6.318 8.109 11.668 8.11v-8.11H35.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44D9E9",
    d: "M67.127 72.274l1.527-42.796a2.565 2.565 0 00-2.564-2.657H47V43.23c5.293 0 9.623 4.345 9.623 9.657 0 5.313-4.33 9.657-9.622 9.657v2.499h4.331c.473 0 .856.383.856.855v.387a2.565 2.565 0 01-2.566 2.565h-2.621v5.9h17.562a2.567 2.567 0 002.564-2.475"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2AB1C0",
    d: "M44.378 68.849a2.566 2.566 0 01-2.565-2.565v-.387c0-.472.382-.855.855-.855H47v-2.498c-5.292 0-9.622-4.345-9.622-9.658 0-5.312 4.33-9.657 9.622-9.657V26.82H27.91a2.564 2.564 0 00-2.563 2.657l1.527 42.796a2.565 2.565 0 002.563 2.473H47V68.85h-2.622zM47 122.462V80.99H24.868a2.565 2.565 0 00-2.524 3.025l7.018 38.507c.085-.029.17-.06.267-.06H47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44D9E9",
    d: "M69.133 80.99H47v41.472h17.374c.096 0 .18.031.266.06l7.017-38.507a2.565 2.565 0 00-2.524-3.025"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M49.6 52.886a2.6 2.6 0 01-2.6 2.601v3.966c3.6 0 6.544-2.954 6.544-6.567 0-3.612-2.944-6.567-6.543-6.567v3.966a2.6 2.6 0 012.6 2.601"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M40.457 52.886c0 3.613 2.944 6.567 6.543 6.567v-3.966a2.6 2.6 0 110-5.202v-3.966c-3.599 0-6.543 2.955-6.543 6.567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B555F",
    d: "M47 43.229v3.09c3.6 0 6.544 2.955 6.544 6.567 0 3.613-2.944 6.567-6.543 6.567v3.091c5.292 0 9.622-4.345 9.622-9.658 0-5.312-4.33-9.657-9.622-9.657"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M37.378 52.886c0 5.313 4.33 9.658 9.623 9.658v-3.091c-3.6 0-6.544-2.954-6.544-6.567 0-3.612 2.944-6.567 6.544-6.567v-3.09c-5.293 0-9.623 4.345-9.623 9.657"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.4 52.886a2.6 2.6 0 002.6 2.601v-5.202a2.6 2.6 0 00-2.6 2.601m5.2 0a2.6 2.6 0 00-2.6-2.601v5.202a2.6 2.6 0 002.6-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M49.623 68.849a2.566 2.566 0 002.565-2.565v-.387a.855.855 0 00-.855-.855H47v3.807h2.622z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M41.813 65.897v.387a2.566 2.566 0 002.565 2.565H47v-3.807h-4.332a.855.855 0 00-.855.855"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#118A97",
    d: "M40.855 75.854a.855.855 0 100 1.71H47v-1.71h-6.145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2AB1C0",
    d: "M54.002 76.71a.855.855 0 00-.856-.856H47v1.71h6.146a.855.855 0 00.856-.855"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#118A97",
    d: "M40.855 78.422a.855.855 0 100 1.71H47v-1.71h-6.145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2AB1C0",
    d: "M54.002 79.277a.855.855 0 00-.856-.855H47v1.71h6.146a.855.855 0 00.856-.855"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B555F",
    d: "M43.022 145.003a2.566 2.566 0 00-2.565 2.565v60.233a2.566 2.566 0 002.565 2.566H47v-65.364h-3.978z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D6771",
    d: "M51.092 145.003h-4.091v65.364h4.091a2.565 2.565 0 002.565-2.566v-60.233a2.566 2.566 0 00-2.565-2.565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D07C2A",
    d: "M29.627 122.462c-.095 0-.181.031-.266.06a.842.842 0 00-.576.944l.552 3.123a.855.855 0 00.843.706h2.779l.06 2.566h-2.137a.856.856 0 00-.843 1.004l.554 3.123a.854.854 0 00.841.706H47v-12.232H29.627z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA852",
    d: "M64.64 122.523c-.086-.03-.17-.06-.267-.06H47v12.231h15.566c.415 0 .77-.298.842-.706l.552-3.123a.854.854 0 00-.841-1.004h-2.137l.06-2.565h2.779c.415 0 .77-.299.841-.707l.554-3.122a.842.842 0 00-.576-.944"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D6771",
    d: "M80.31 50.687a2.246 2.246 0 00-2.205 1.82h-7.148v.854h7.148a2.246 2.246 0 102.205-2.674"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B555F",
    d: "M23.043 52.506h-7.148a2.247 2.247 0 00-2.205-1.82 2.248 2.248 0 000 4.495 2.247 2.247 0 002.205-1.82h7.148v-.855z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA852",
    d: "M63.603 43.207h-7.426a13.437 13.437 0 014.08 9.658c0 3.79-1.57 7.22-4.08 9.657h7.426c5.23 0 9.51-4.345 9.51-9.657 0-5.311-4.28-9.658-9.51-9.658"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D07C2A",
    d: "M30.398 43.207h7.425a13.437 13.437 0 00-4.08 9.658c0 3.79 1.57 7.22 4.08 9.657h-7.425c-5.231 0-9.511-4.345-9.511-9.657 0-5.311 4.28-9.658 9.511-9.658"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#118A97",
    d: "M79.731 82.332l-10.578 3.083a5.502 5.502 0 01-6.946-4.258 1.711 1.711 0 011.362-1.999l17.118-3.242c1.431-.271 2.524 1.256 1.806 2.522l-1.752 3.095c-.22.388-.582.675-1.01.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M47.897 50.71a1.28 1.28 0 112.56 0 1.28 1.28 0 01-2.56 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B555F",
    d: "M33.35 124.91a1.302 1.302 0 11-2.602-.002 1.302 1.302 0 012.601.001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D6771",
    d: "M60.651 124.91a1.301 1.301 0 102.603 0 1.301 1.301 0 00-2.603-.001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B555F",
    d: "M39.33 124.91a1.301 1.301 0 11-2.6 0 1.301 1.301 0 012.599-.001m-2.94 7.369a1.3 1.3 0 11-2.6-.001 1.3 1.3 0 012.599.001m7.98 0a1.3 1.3 0 11-2.602 0 1.301 1.301 0 112.602 0m.943-7.368a1.301 1.301 0 11-2.603 0 1.301 1.301 0 012.603-.001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D6771",
    d: "M51.292 124.91a1.301 1.301 0 11-2.6 0 1.301 1.301 0 012.599-.001m5.982.001a1.301 1.301 0 11-2.603 0 1.301 1.301 0 012.603-.001m.452 7.369a1.3 1.3 0 102.602-.002 1.3 1.3 0 00-2.602.002m-5.377 0a1.3 1.3 0 11-2.602 0 1.3 1.3 0 112.602 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M56.518 107.522H37.481c-.615 0-1.14-.452-1.23-1.061l-1.496-9.958a1.247 1.247 0 011.232-1.43h22.026c.762 0 1.344.677 1.231 1.43l-1.494 9.958a1.244 1.244 0 01-1.232 1.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M47 107.522h-9.518c-.617 0-1.14-.452-1.232-1.061l-1.494-9.958a1.245 1.245 0 011.231-1.43H47v12.449z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D6771",
    d: "M35.988 96.007a.308.308 0 00-.236.108.318.318 0 00-.073.25l1.495 9.957a.309.309 0 00.308.265h19.037a.31.31 0 00.307-.265l1.494-9.957a.3.3 0 00-.072-.25.31.31 0 00-.235-.108H35.988zm20.53 12.449H37.483a2.166 2.166 0 01-2.155-1.857l-1.495-9.957a2.18 2.18 0 012.156-2.503h22.025a2.177 2.177 0 012.155 2.503l-1.495 9.957a2.164 2.164 0 01-2.154 1.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B555F",
    d: "M47 96.007H35.989a.31.31 0 00-.236.108.318.318 0 00-.073.25l1.495 9.957a.31.31 0 00.308.265H47v1.869h-9.518a2.166 2.166 0 01-2.155-1.857l-1.495-9.957a2.18 2.18 0 012.156-2.503H47v1.868z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D07C2A",
    d: "M60.982 129.861H33.019l-.06-2.565h28.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A65E16",
    d: "M46.97 129.861H32.988l-.03-2.565H47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE7F7F",
    d: "M44.11 101.11h-.602v-2.626c0-.3-.243-.543-.544-.543H40.72c-.3 0-.544.243-.544.543v2.625h-.602a.544.544 0 00-.398.914l2.269 2.427c.215.23.579.23.793 0l2.268-2.427a.543.543 0 00-.397-.914"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#51D385",
    d: "M54.822 100.54l-2.267-2.427a.545.545 0 00-.794 0l-2.268 2.427a.544.544 0 00.397.914h.603v2.625c0 .3.243.543.543.543h2.243c.3 0 .544-.243.544-.543v-2.625h.602a.543.543 0 00.397-.914"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA852",
    d: "M64.713 77.776c0-1.003.706-1.805 1.638-2.034v-3.165c-.932-.229-1.638-1.03-1.638-2.034 0-1.178.954-2.132 2.132-2.132h7.942v-6.856a2.698 2.698 0 012.699-2.697 2.698 2.698 0 012.699 2.697v23.837c0 1.048-.85 1.897-1.899 1.897H66.845a2.131 2.131 0 01-2.132-2.132c0-1.003.706-1.805 1.638-2.034V79.81c-.932-.228-1.638-1.03-1.638-2.033"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#025B65",
    d: "M14.27 82.332l10.578 3.083a5.501 5.501 0 006.945-4.258 1.71 1.71 0 00-1.362-1.999l-17.118-3.242c-1.43-.271-2.524 1.256-1.806 2.522l1.752 3.095c.22.388.583.675 1.01.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D07C2A",
    d: "M29.288 77.776c0-1.003-.707-1.805-1.639-2.034v-3.165c.932-.229 1.64-1.03 1.64-2.034a2.133 2.133 0 00-2.133-2.132h-7.942v-6.856a2.698 2.698 0 00-2.7-2.697 2.698 2.698 0 00-2.699 2.697v23.837c0 1.048.85 1.897 1.899 1.897h11.442a2.132 2.132 0 002.132-2.132c0-1.003-.707-1.805-1.639-2.034V79.81c.932-.228 1.64-1.03 1.64-2.033M11.423 87.29a1.538 1.538 0 01-1.537-1.538V70.386a1.537 1.537 0 013.075 0v15.366c0 .849-.689 1.537-1.538 1.537"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA852",
    d: "M82.577 87.29c.849 0 1.538-.689 1.538-1.538V70.386a1.537 1.537 0 00-3.076 0v15.366c0 .849.689 1.537 1.538 1.537"
  }))));
}

export default SvgHelperRobotComplete;